import { Component, inject, OnInit } from '@angular/core';
import { clearStorage } from '../../../../../shared/src/lib/utils/utils';
import { ParamsPath } from '@core/enums';
import { firstValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@core/envs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonLibComponent } from '@components/atoms';
import { CountryListService } from 'libs/core/src/services/country/country-list.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-error-feedback',
  standalone: true,
  imports: [ButtonLibComponent, TranslateModule],
  templateUrl: './route-error-feedback.component.html',
  styleUrls: ['./route-error-feedback.component.scss'],
})
export class RouteErrorFeedbackComponent implements OnInit {
  readonly route = inject(ActivatedRoute);
  readonly translate = inject(TranslateService);
  readonly countryListService = inject(CountryListService);

  errorCode!: string;
  typeError!: string;
  loginSelectedCountry!: string;
  title!: string;
  description!: string;
  chatButton!: string;
  closeButton!: string;

  async ngOnInit(): Promise<void> {
    const params = await firstValueFrom(this.route.params);

    this.errorCode = params[ParamsPath.UNAUTHORIZED_ERROR_CODE];
    this.typeError = params[ParamsPath.INVALID_COUNTRY_TYPE_ERROR];
    this.loginSelectedCountry = params[ParamsPath.COUNTRY];

    const tempLanguage = this.countryListService.getCountryByCode(this.loginSelectedCountry)?.language as string;

    await firstValueFrom(this.translate.use(tempLanguage));

    const translatePath = `error.${this.errorCode}.${this.typeError}`;

    this.title = `${translatePath}.title`;
    this.description = `${translatePath}.description`;
    this.chatButton = `${translatePath}.chat-button`;
    this.closeButton = `${translatePath}.close-button`;
  }

  readonly redirectToWhatsAppChatbot = (): void => {
    window.open(this.translate.instant('whatsapp.redirect.link'));
  }

  readonly doLogout = (): void => {
    clearStorage();
    const param = this.loginSelectedCountry ? `?${ParamsPath.COUNTRY_FMA}=${this.loginSelectedCountry}` : '';
    window.open(`${environment.project.shell}logout${param}`, '_self')?.focus();
  }
}
